import {
  INTEREST_LEVELS_LOAD_REQUEST,
  INTEREST_LEVELS_LOAD_SUCCESS,
  INTEREST_LEVELS_LOAD_FAILURE,
  INTEREST_LEVEL_EDIT_START,
  INTEREST_LEVEL_EDIT_CANCEL,
  INTEREST_LEVEL_SAVE_SUCCESS,
  INTEREST_LEVEL_CREATE_SUCCESS,
  INTEREST_LEVEL_DEL_REQUEST,
  INTEREST_LEVEL_DEL_SUCCESS,
  INTEREST_LEVEL_DEL_FAILURE,
} from '../actions/interestLevel';

const initialState = {
  interestLevels: [],
  loaded: false,
  editing: {},
  saveError: {},
  loading_interestLevels: false,
};

function initializeState(){
  return Object.assign({}, initialState);
}

export default function interestLevel(state = initializeState(), action = {}) {
  switch (action.type) {
    case INTEREST_LEVELS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        loading_interestLevels: true,
      };
    case INTEREST_LEVELS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        interestLevels: action.interestLevels,
        error: null,
        loading_interestLevels: false,
      };
    case INTEREST_LEVELS_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        interestLevels: [],
        error: action.error,
        loading_interestLevels: false,
      };
    case INTEREST_LEVEL_EDIT_START:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: true
        }
      };
    case INTEREST_LEVEL_EDIT_CANCEL:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: false
        }
      };

    case INTEREST_LEVEL_SAVE_SUCCESS:
      let interestLevels = [...state.interestLevels];
      let interestLevelData = [];
      for (const [index, interestLevel] of interestLevels.entries()) {
        if (interestLevel.id === action.id) {
          interestLevelData = [
            ...interestLevels.slice(0, index),
            action.interestLevel,
            ...interestLevels.slice(index + 1)
          ];
        }
      }
      return {
        ...state,
        interestLevels: interestLevelData,
        loading_interestLevels: false,
        editing: {
          ...state.editing,
          [action.id]: false
        },
      };
    case INTEREST_LEVEL_CREATE_SUCCESS:
      interestLevels = [...state.interestLevels];
      return {
        ...state,
        interestLevels: [...interestLevels, action.interestLevel],
        loading_interestLevels: false,
        editing: {
          ...state.editing,
          [action.id]: false
        },
      };

    case INTEREST_LEVEL_DEL_REQUEST:
      return {
        ...state,
        deleting: true,
        loading_interestLevels: true,
      };
    case INTEREST_LEVEL_DEL_SUCCESS:
      interestLevels = [...state.interestLevels];
      for (const [index, interestLevel] of interestLevels.entries()) {
        if (interestLevel.id === action.interestLevel.id) {
          interestLevels.splice( index, 1 );
        }
      }
      return {
        ...state,
        deleting: false,
        deleted: true,
        interestLevels: interestLevels,
        error: null,
        loading_interestLevels: false,
      };
    case INTEREST_LEVEL_DEL_FAILURE:
      return {
        ...state,
        deleting: false,
        deleted: false,
        error: action.error,
        loading_interestLevels: false,
      };

    case 'INTEREST_LEVEL_SAVE_REQUEST':
      return {
        ...state,
        loading_interestLevels: true,
      }

    case 'INTEREST_LEVEL_SAVE_FAILURE':
      return {
        ...state,
        loading_interestLevels: false,
      }
    default:
      return state;
  }
}
